<template>
  <div style="position: absolute; inset: 0; background: #fff">
    <div
      style="
        font-weight: 700;
        font-size: 0.65rem;
        line-height: 0.9rem;
        margin-top: 0.8rem;
        margin-left: 0.5rem;
      "
    >
      <div>您好，</div>
      <div>欢迎来到网申系统</div>
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgb(204, 204, 204);
        margin: 0.5rem;
        padding-bottom: 0.3rem;
        margin-top: 1.5rem;
      "
    >
      <img
        style="height: 0.6rem"
        src="../../assets/img/5601f356010cfbd637311f15647a664.png"
        alt=""
        srcset=""
      />
      <van-field v-model="phone" placeholder="请输入手机号" />
    </div>
    <div
      style="
        display: flex;
        align-items: center;
        border-bottom: 1px solid rgb(204, 204, 204);
        margin: 0.5rem;
        padding-bottom: 0.3rem;
        margin-top: 0.8rem;
      "
    >
      <img
        style="height: 0.6rem"
        src="../../assets/img/919cbcbcb54eb35b72d7564ccad1928.png"
        alt=""
        srcset=""
      />
      <van-field maxlength="4" v-model="smsCode" placeholder="请输入验证码" />
      <div v-if="verifytime == 0" @click="verify" class="verify">
        发送验证码
      </div>
      <div v-if="verifytime != 0" class="verify">{{ verifytime }}秒</div>
    </div>
    <div style="padding-left: 0.5rem">
      <van-checkbox v-model="checked">
        <div style="padding-left: 0.2rem; font-size: 0.3rem; color: #ccc">
          我已阅读并同意<a
            style="color: #1e88e5"
            href="https://www.kakayuy.net/newAgree2.html"
            >注册协议</a
          >和<a
            style="color: #1e88e5"
            href="https://www.kakayuy.net/newAgree1.html"
            >隐私政策</a
          >
        </div>
      </van-checkbox>
    </div>
    <div
      v-if="checked && phone.toString().length == 11 && smsCode"
      @click="onSubmit"
      style="
        background-image: linear-gradient(to right, #005aeb, #3a9cf5);
        color: #fff;
        text-align: center;
        width: 80%;
        margin: auto;
        margin-top: 1.5rem;
        line-height: 1.3rem;
        border-radius: 3rem;
      "
    >
      注册
    </div>
    <div
      v-else
      style="
        background: #ccc;
        color: #fff;
        text-align: center;
        width: 80%;
        margin: auto;
        margin-top: 1.5rem;
        line-height: 1.3rem;
        border-radius: 3rem;
      "
    >
      注册
    </div>
  </div>
</template>

<script>
import { api } from "../../biz/api";
import Vue from "vue";
import { Field } from "vant";
import { Checkbox, CheckboxGroup } from "vant";
import { Toast } from "vant";

Vue.use(Toast);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Field);
export default {
  data() {
    return {
      verifytime: 0,
      phone: "",
      smsCode: "",
      checked: true,
    };
  },
  mounted() {},
  methods: {
    onSubmit() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      api
        .UserAdd({
          phone: this.phone,
          smsCode: this.smsCode,
          userId: this.$route.query.u,
          wxCode: this.getCode(),
        })
        .then((res) => {
          if (res.body.status == 1) {
            alert(res.body.message);
            this.$router.push({
              path: "/succeed",
            });
          }
        });
    },
    getCode() {
      let vars = window.location.search.split("&");
      let pair = vars[0].split("=");
      if (pair[0] == "?code") {
        return pair[1];
      } else {
        return "";
      }
    },
    verify() {
      if (this.phone) {
        if (this.verifytime == 0) {
          this.verifytime = 60;
          var yz = setInterval(() => {
            this.verifytime--;
            if (this.verifytime == 0) {
              clearInterval(yz);
            }
          }, 1000);
          api.SmsLogin(this.phone).then((data) => {
            // if (data.data.status == 1) {
            //   alert(data.data.message);
            // }
          });
        }
      } else {
        alert("请输入手机号");
      }
    },
  },
};
</script>

<style lang="less">
.van-field__control {
  font-size: 0.45rem;
}
.van-cell::after {
  display: none;
}
.verify {
  background-image: linear-gradient(to right, #005aeb, #3a9cf5);
  width: 4rem;
  color: #fff;
  text-align: center;
  padding: 0.25rem 0.3rem;
  font-size: 0.35rem;
  border-radius: 3rem;
}
.van-checkbox__icon--checked .van-icon {
  font-size: 0.3rem;
}
.van-checkbox__icon {
  display: flex;
  align-items: center;
}
</style>

